import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'velocity-loader-fill',
  templateUrl: './loader-fill.component.html',
  styleUrls: ['./loader-fill.component.scss']
})
export class LoaderFillComponent implements OnInit {

  @Input() message: string = "LOADING";
  @Input() animationType: string = "bouncy-ball";

  ngOnInit() {
  }

}
